export type Browser = 'chrome' | 'chrome_android' | 'edge' | 'firefox' | 'firefox_android' | 'safari' | 'safari_ios'

export const browsersMinimalVersions: Record<Browser, number> = {
  chrome: 125,
  chrome_android: 125, // eslint-disable-line camelcase
  edge: 125,
  firefox: 128,
  firefox_android: 128, // eslint-disable-line camelcase
  safari: 18,
  safari_ios: 18, // eslint-disable-line camelcase
}

const supportedBrowsers = Object.keys(browsersMinimalVersions)

const isBrowserSupported = (): boolean => {
  if (/bot|googlebot|crawler|spider|robot|crawling|headless|lighthouse|notebooklm/i.test(navigator.userAgent)) return true

  const userAgent = navigator.userAgent
  const browserVersion = userAgent.match(/(Chrome|Firefox|Safari|Edg)\/(\d+)/)

  if (!browserVersion) return false

  const [_, browser, version] = browserVersion
  if (!supportedBrowsers.includes(browser.toLowerCase())) return false

  const versionNumber = parseInt(version, 10)

  return browsersMinimalVersions[browser.toLowerCase() as Browser] <= versionNumber
}

export const deletePage = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (isBrowserSupported()) {
      resolve()
      return
    }

    import('@core/views/error/obsolete').then(({ generateObsoletePage }) => {
      const body = document.querySelector('body')
      if (body) {
        body.innerHTML = ''
        const { main, footer } = generateObsoletePage(navigator.userAgent)
        body.appendChild(main)
        body.appendChild(footer)
      }

      reject(new Error('Unsupported browser'))
    })
  })
}
